module.exports = __webpack_public_path__ + "img/b_01.143ac2fb.png";